// src/components/Sidebar.js
import React from "react";
import "./Header.css";
import { FaTachometerAlt, FaExchangeAlt, FaChartBar, FaCog } from "react-icons/fa";

const Sidebar = ({ isOpen }) => {
  return (
    <div className={`sidebar ${isOpen ? '' : 'sidebar-collapsed'}`}>
      <h2 className="logo">
        <img src="assets/images/TransactionAnalysts.png" alt="TA Logo" width={isOpen ? 170 : 40} height={isOpen ? 80 : 40} />
      </h2>
      <ul className="nav-links">
        <li>
          <a href="/taadmin">
            <FaTachometerAlt style={{ marginRight: "10px" }} />
            {isOpen && "Dashboard"}
          </a>
        </li>
        <li>
          <a href="/taadmin/new-job-form">
            <FaExchangeAlt style={{ marginRight: "10px" }} />
            {isOpen && "Jobs"}
          </a>
        </li>
        {/* <li>
          <a href="/reports">
            <FaChartBar style={{ marginRight: "10px" }} />
            {isOpen && "Reports"}
          </a>
        </li> */}
        <li>
          <a href="/">
            <FaCog style={{ marginRight: "10px" }} />
            {isOpen && "Logout"}
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
